module.exports = __webpack_public_path__ + "static/quote_1-230a3a465ef840c7ee8e1adda16472fc.png";